import React from 'react'
import './Loading.css'

const Loading = ({ visible }) => {
  return visible ? (
    <div className="opacity-exito">
      <div className="loading"></div>
    </div>
  ) : null
}

export default Loading
